module.exports = __webpack_public_path__ + "clothes.7c6fc940c2eac6274b93.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/clothes/webfont/clothes.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/clothes/webfont/clothes.ttf
// module chunks = styles